import React from "react";

const ErrorPage = () => (
  <div style={{ textAlign: "center", marginTop: "10rem" }}>
    <h1 className="fs-5" style={{ color: "red", marginTop: "10px" }}>
      Oops! The page you are looking for does not exist.
    </h1>
    <p>404 - Page Not Found</p>
  </div>
);

export default ErrorPage;
